import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MorningRitualsMiddayBites from "./sections/MorningRitualsMiddayBites";
import TheEuropeanPantry from "./sections/TheEuropeanPantry";
import SeasonalSips from "./sections/SeasonalSips";
import JoinTheNeighborhood from "./sections/JoinTheNeighborhood";
import Businessservices from "./sections/Businessservices";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Businessservices />
      <MorningRitualsMiddayBites />
      <TheEuropeanPantry />
      <SeasonalSips />
      <JoinTheNeighborhood />
      <Footer />
    </div>;
}